import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { checkDpSuccess, getFormErrorMessage, getMaskedString } from "../../utility/service/tool-service";
import { MessageContext,handleSuccessMessage } from "../../store/messageStore";
import { SystemLoading,checkLoading } from "../../store/loadingStore";
import { B1010103Before, queryFeRolesList, queryFeUsersInfo, updateFeUsersInfo } from "../../utility/service/account-service";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { addFormValidator } from "../../utility/validate/formValidator";
import { MaskedFormInput } from "../../components/MaskedFormInput";
import { updateAuditEyesEvent } from "../../utility/service/audilog-service";
import { useFuncId } from "../../router/menuRouterMapper";
import { useEditableFlag } from '../../hooks/useEditableFlag';

export default function AccountList_Detail({backToUrl="accountList"}){

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [detailObj,setDetailObj] = useState({});
    const [, dispatch] = useContext(MessageContext); //訊息視窗  
    const [,loading] = useContext(SystemLoading);
    const [editAction,setEditAction] = useState('detail');//設定目前的動作
    const [ roleList,setRoleList] = useState([]);
    const [userStatusList,setUserStatusList] = useState([]);
    const [formRule, setFormRule] = useState([]); //表單驗證
    const [maskView,setMaskView]=useState(false)
    const chsFuncId = useFuncId();
    const isEditable = useEditableFlag('B10101'); // control edit by B10101


    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
            name:'',
            useTypes: []
        },
        //錯誤驗證時機
        mode: "all"
      });

    const btnBackTo = ()=>{
        navigate(`/management/${backToUrl}`);
    }

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }

    const onSubmit = (data) => {
       let reqBody = {
        userSeq:detailObj?.userSeq,
        userName:data.userName,
        // phone:data.phone,
        email:data.email,
        status:data.status,
        roleSeq:data.roleSeq
       }
       updateFeUsersInfo(reqBody)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
                    btnBackTo();
                    
                }
            })

       
      }


    useEffect(()=>{
        if((action)!==''){
            setEditAction(action);
            axios_getCreateBefore();
            axios_queryFeRolesList();
            axios_getUserStatusList();
            axios_queryFeUsersInfo();
        }else{
            btnBackTo();
        }
    },[action])

      //建立前查詢form 規則
  const axios_getCreateBefore = ()=>{
    B1010103Before()
      .then((res)=>{
          if(checkDpSuccess(res)){
              let array = []
              res?.data?.RespBody?.constraints?.forEach((item) => {
                  const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                  array.push(result)
              })
              setFormRule(array);
          }
      })
}

    const setValidForm = useCallback((formId) => {
        if (formRule?.length > 0) {
            const tmp = formRule?.find((item) => {
                return Object.keys(item)[0] === formId
            });
            return tmp ? tmp[formId] : '';
        }
    }, [formRule]);

    const axios_queryFeUsersInfo = ()=>{
        checkLoading(loading);
        queryFeUsersInfo({userSeq:itemObj?.userSeq})
            .then((res)=>{
                let data = res?.data?.RespBody;
                setDetailObj(data);
                setValue("userName",data?.userName, { shouldValidate: true }); //name 等API 改完後 須改為userName
                setValue("roleSeq",data?.roleSeq, { shouldValidate: true });
                setValue("phone",data?.phone, { shouldValidate: true });
                setValue("email",data?.email, { shouldValidate: true });
                setValue("status",data?.status, { shouldValidate: true });
                clearErrors();

            }).finally((fin)=>{checkLoading(loading,false);})
    }

    const axios_queryFeRolesList = ()=>{ //公司角色清單
        queryFeRolesList({companySeq:itemObj?.companySeq})
            .then((res)=>{
                if(checkDpSuccess(res)){
                    let data = res.data.RespBody?.roles?.options;
                    setRoleList(data);
                }
            })
    }

    const axios_getUserStatusList = ()=>{
        getSubItemsByItemNo('USER_STATUS',22)
        .then((res)=>{
            if(checkDpSuccess(res)){
                let data = res.data.RespBody.subItems;
                let newArray = data.map((item, index) => {
                  return {
                    ...item,
                    index: index,
                  }
                })
                setUserStatusList(newArray);
            }
        })
      }
     
    const handleMaskClick = ()=>{
    setMaskView(prev => {
        return !prev;
        });
    }
    
    const axios_updateAuditEyesEvent = ()=>{
        updateAuditEyesEvent({
            functionId:chsFuncId,
            eventType:"E"
        })
        .then((res)=>{
            if(checkDpSuccess(res)){

            }
        })
    }


    return (
    <>
    {/* 返回上頁 */}
    <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
            <Button rounded text onClick={() => { btnBackTo(); }}>
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t('button.return_to_list')}
            </Button>
        </div>
    </div>
    <div className="p-card">
        <div className="p-card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid">
                {/*使用者帳號*/}
                <div className='col-12 lg:col-3'>
                    <label
                        className="form-label">
                        {t("user_acct")}
                    </label>
                    <span>{!maskView?getMaskedString("account",detailObj?.acct):detailObj?.acct}</span>
                    
                </div>
                {/*使用者名稱*/}
                <div className='col-12 lg:col-3'>
                {/* <FormInput
                        register={register}
                        errors={errors}
                        id="userName"
                        type="text"
                        labelClass={`control-label ${editAction==='update'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('user_name')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("userName")}
                    /> */}
                <Controller
                    name="userName"
                    control={control}
                    rules={setValidForm("userName")}
                    render={({ field, fieldState }) => (
                        <MaskedFormInput
                        {...field}
                        type="text"
                        labelClass={`control-label ${editAction==='update'?'required':''}`}
                        labelText={t('user_name')}
                        maskType="name"
                        maskView={maskView}
                        setMaskView={() => handleMaskClick()}
                        disabled={editAction==='detail'}
                        errorMessage={fieldState.error?.message}
                        onKeyDown={checkKeyDown}
                        />
                    )}
                />    
                </div>
                {/* 角色 */}
                <div className='col-12 lg:col-3'>
             
                <label
                    htmlFor="roleSeq"
                    className={`form-label ${editAction !== "detail" ? 'required' : ''}`}>
                    {t("role")}
                </label>
                <Controller
                    name="roleSeq"
                    control={control}
                    rules={setValidForm("roleSeq")}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            disabled={editAction==='detail'}
                            filter
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="roleSeq"
                            control={control}
                            options={roleList}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )}
                />

                </div>
                 {/* 狀態 */}
                 <div className='col-12 lg:col-3'>
                <label
                    htmlFor="status"
                    className={`form-label ${editAction !== "detail" ? 'required' : ''}`}>
                    {t("status")}
                </label>
                <Controller
                    name="status"
                    control={control}
                    rules={setValidForm("status")}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            disabled={editAction==='detail'}
                            filter
                            optionLabel="subitemName"
                            optionValue="subitemNo"
                            value={field.value}
                            virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="status"
                            control={control}
                            options={userStatusList}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )}
                />
                 </div>
            </div>
            <div className="grid my-1">
                {/* <div className="col-12 lg:col-3">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="phone"
                        type="text"
                        labelClass={`control-label ${editAction==='update' || editAction==='create'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('userPhone')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("phone")}
                    />
                </div> */}
                <div className="col-12 lg:col-3">
                    {/* <FormInput
                        register={register}
                        errors={errors}
                        id="email"
                        type="text"
                        labelClass={`control-label ${editAction==='update' || editAction==='create'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('user_email')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("email")}
                        
                    /> */}
                     <Controller
                        name="email"
                        control={control}
                        rules={setValidForm("email")}
                        render={({ field, fieldState }) => (
                            <MaskedFormInput
                            {...field}
                            type="email"
                            labelClass={`control-label ${editAction==='update' || editAction==='create'?'required':''}`}
                            labelText={t('user_email')}
                            maskType="email"
                            maskView={maskView}
                            setMaskView={() => handleMaskClick()}
                            disabled={editAction==='detail'}
                            errorMessage={fieldState.error?.message}
                            onKeyDown={checkKeyDown}
                            />
                        )}
                    />
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t('jwtIssuer')}
                    </label>
                    <span>{detailObj?.issuer}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t('wrongPwdAttempts')}
                    </label>
                    <span>{detailObj?.errorCount}</span>
                </div>
            </div>   
            <div className="grid my-1">
            <div className='col-12 lg:col-3'>
                <label
                    className="form-label">
                    {t("org_name")}
                </label>
                <span>{detailObj?.companyName}</span>
            </div>
               
            <div className='col-12 lg:col-3'>
                <label
                    className="form-label">
                    {t("type")}
                </label>
                <span>{detailObj?.companyTypeName}</span>
            </div>
            <div className='col-12 lg:col-3'>
                <label
                    className="form-label">
                    {t("lastLoginIp")}
                </label>
                <span>{detailObj?.lastLoginIp}</span>
            </div>
               
            <div className='col-12 lg:col-3'>
                <label
                    className="form-label">
                    {t("lastLoginTime")}
                </label>
                <span>{detailObj?.lastLogin}</span>
            </div>
            </div>
                  
            <div className="grid">
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("create_user")}
                    </label>
                    <span>{detailObj?.createUser}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("create_date")}
                    </label>
                    <span>{detailObj?.createDateTime}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("update_user")}
                    </label>
                    <span>{detailObj?.updateUser}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("update_date")}
                    </label>
                    <span>{detailObj?.updateDateTime}</span>
                </div>
            </div>
            <div className="col-12 gap-2 flex-all-center">
              {
                ( editAction === 'detail') ?( <div className="col-12 gap-2 flex-all-center">
                    <Button disabled={!isEditable} label={t("button.edit")} onClick={(e) => {
                        e.preventDefault();
                        setEditAction('update');
                        setMaskView(true);
                        axios_updateAuditEyesEvent();
                    }} type="button" size="small" />
                </div>):(<>
                    <Button disabled={!isValid} type="submit" label={t("button.confirm")} size="small" />
                    <Button outlined size="small" type="button" label={t("button.cancel")} onClick={(e) => {
                         setMaskView(false);
                         btnBackTo();
                    }} />
                </>)
              }
            </div>
            </form>
          
        </div>
    </div>
    </>
    )
}